
import findIndex from './findIndex';

function removeAsset(assets, assetId) {
  if (!assets) {return assets;}

  const newAssets = assets.slice();

  newAssets.splice(findIndex(newAssets, assetId), 1);

  return newAssets;
}

export default removeAsset;